import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaEye, FaExternalLinkAlt } from 'react-icons/fa';

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const projects = [
    { id: 1, title: 'Infrastructure Réseau Entreprise',  category: 'network',    image: 'https://via.placeholder.com/400x300/2563eb/ffffff?text=Réseau+IT',    description: "Mise en place d'une infrastructure réseau complète pour une entreprise de 200 employés", technologies: ['Cisco', 'Fortinet', 'VMware'] },
    { id: 2, title: 'Pièce Décorative Métallique',       category: 'metalwork',  image: 'https://via.placeholder.com/400x300/059669/ffffff?text=Découpage+Métal', description: "Création d'éléments décoratifs en acier inoxydable pour hall d'entreprise", technologies: ['Découpage Laser', 'Acier Inox', 'Finition Brossée'] },
    { id: 3, title: 'Solution IT Sur Mesure',            category: 'software',   image: 'https://via.placeholder.com/400x300/7c3aed/ffffff?text=Solution+IT',    description: "Développement d'une application de gestion intégrée", technologies: ['React', 'Node.js', 'PostgreSQL'] },
    { id: 4, title: 'Système Téléphonique IP',           category: 'network',    image: 'https://via.placeholder.com/400x300/dc2626/ffffff?text=VoIP+System',    description: "Installation d'un système téléphonique IP pour centre d'appels", technologies: ['Asterisk', 'VoIP', 'SIP'] },
    { id: 5, title: 'Signalétique Artistique',           category: 'metalwork',  image: 'https://via.placeholder.com/400x300/ea580c/ffffff?text=Signalétique',   description: 'Conception et fabrication de signalétique métallique personnalisée', technologies: ['Aluminium', 'Gravure', 'Impression'] },
    { id: 6, title: 'Plateforme E-commerce',             category: 'software',   image: 'https://via.placeholder.com/400x300/0891b2/ffffff?text=E-commerce',     description: "Développement d'une plateforme e-commerce complète", technologies: ['Vue.js', 'Laravel', 'MySQL'] },
  ];

  const filters = [
    { key: 'all',       label: 'Tous les Projets' },
    { key: 'network',   label: 'Réseaux & IT' },
    { key: 'metalwork', label: 'Métallurgie' },
    { key: 'software',  label: 'Développement' },
  ];

  const filteredProjects = activeFilter === 'all'
    ? projects
    : projects.filter(p => p.category === activeFilter);

  return (
    <div style={{ paddingTop: '80px' }}>

      {/* ── HERO ── */}
      <section className="hero-section">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={10}>
              <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="display-2 fw-bold mb-4">
                Notre Portfolio
              </motion.h1>
              <motion.p initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="lead" style={{ color: 'rgba(255,255,255,0.9)' }}>
                Découvrez nos réalisations dans les domaines de l'IT, des télécommunications et de la fabrication métallique
              </motion.p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ── FILTERS ── */}
      <section className="py-5 bg-light-custom">
        <Container>
          <Row><Col className="text-center">
            <div className="portfolio-filters">
              {filters.map((filter) => (
                <Button key={filter.key} onClick={() => setActiveFilter(filter.key)} className={`filter-btn ${activeFilter === filter.key ? 'active' : ''}`} variant="outline-primary">
                  {filter.label}
                </Button>
              ))}
            </div>
          </Col></Row>
        </Container>
      </section>

      {/* ── GRID ── */}
      <section className="section-padding">
        <Container>
          <Row className="g-4">
            {filteredProjects.map((project, index) => (
              <Col lg={4} md={6} key={project.id}>
                <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} transition={{ duration: 0.5, delay: index * 0.1 }}>
                  <Card className="portfolio-item card-custom h-100">
                    <div className="position-relative overflow-hidden">
                      <Card.Img variant="top" src={project.image} alt={project.title} style={{ height: '200px', objectFit: 'cover' }} />
                      <div className="portfolio-overlay">
                        <Button variant="light" className="me-2"><FaEye /></Button>
                        <Button variant="light"><FaExternalLinkAlt /></Button>
                      </div>
                    </div>
                    <Card.Body className="p-4">
                      <Card.Title className="h5 mb-3">{project.title}</Card.Title>
                      <Card.Text className="text-muted-custom mb-3" style={{ fontSize: '0.9rem' }}>{project.description}</Card.Text>
                      <div className="d-flex flex-wrap gap-2">
                        {project.technologies.map((tech, idx) => (
                          <Badge key={idx} bg="primary" className="rounded-pill" style={{ fontSize: '0.75rem' }}>{tech}</Badge>
                        ))}
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ── CTA ── */}
      <section className="section-padding" style={{ background: 'var(--dark-color)', color: 'white' }}>
        <Container>
          <Row><Col className="text-center">
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
              <h2 className="display-4 fw-bold mb-4">Prêt à Démarrer Votre Projet ?</h2>
              <p className="lead mb-5" style={{ color: 'rgba(255,255,255,0.8)' }}>
                Contactez-nous pour discuter de vos besoins et découvrir comment nous pouvons vous accompagner dans la réalisation de vos projets technologiques
              </p>
              <Button as="a" href="/contact" className="btn-custom-primary" size="lg">
                Demander un Devis
              </Button>
            </motion.div>
          </Col></Row>
        </Container>
      </section>
    </div>
  );
};

export default Portfolio;